function fixedNav() {

  let pos_nav = $('.meal-service-nav').offset().top;

  $(window).on('scroll', function () {

    if ($(window).scrollTop() > pos_nav) {
      $('.meal-service-nav').addClass('fixed-nav')
    } else {
      $('.meal-service-nav').removeClass('fixed-nav')
    }

  });

}

if ($('.meal-service-nav').length > 0) {
  fixedNav();
}